import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import "../assets/styles/Contact.scss";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "../hooks/usePageTitle";

function Contact() {
  const { t } = useTranslation();
  usePageTitle('Contact');

  return (
    <section className="contact-section">
      <div className="contact-header">
        <h1>{t("contactTitle")}</h1>
        <div className="contact-rule" />
        <p className="contact-subtitle">{t("contactDesc")}</p>
      </div>

      <div className="contact-card">
        <div className="contact-links">
          <a
            href="mailto:nadjialstephane1@gmail.com"
            className="contact-link"
          >
            <AlternateEmailIcon />
            <div className="contact-link-body">
              <span className="contact-link-label">{t("contactEmail")}</span>
              <span className="contact-link-value">nadjialstephane1@gmail.com</span>
            </div>
          </a>

          <a
            href="https://www.linkedin.com/in/st%C3%A9phane-mbangossoum-221609198/"
            target="_blank"
            rel="noreferrer"
            className="contact-link"
          >
            <LinkedInIcon />
            <div className="contact-link-body">
              <span className="contact-link-label">LinkedIn</span>
              <span className="contact-link-value">Stéphane Mbangossoum</span>
            </div>
          </a>

          <a
            href="https://github.com/nadjial"
            target="_blank"
            rel="noreferrer"
            className="contact-link"
          >
            <GitHubIcon />
            <div className="contact-link-body">
              <span className="contact-link-label">GitHub</span>
              <span className="contact-link-value">github.com/nadjial</span>
            </div>
          </a>
        </div>

      </div>
    </section>
  );
}

export default Contact;
